var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFigma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 25,
    viewBox: "0 0 17 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.13859 24.9087C6.42311 24.9087 8.27724 23.0558 8.27724 20.7726V16.6362H4.13859C1.85407 16.6362 0 18.4893 0 20.7726C0 23.0558 1.85407 24.9087 4.13859 24.9087Z",
    fill: "#0ACF83"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 12.5C0 10.2167 1.85407 8.36374 4.13859 8.36374H8.27724V16.6363H4.13859C1.85407 16.6363 0 14.7832 0 12.5Z",
    fill: "#A259FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.000488281 4.22751C0.000488281 1.94432 1.85462 0.0912781 4.13915 0.0912781H8.27774V8.36381H4.13915C1.85462 8.36381 0.000488281 6.5107 0.000488281 4.22751Z",
    fill: "#F24E1E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.2771 0.0912781H12.4157C14.7001 0.0912781 16.5543 1.94432 16.5543 4.22751C16.5543 6.5107 14.7001 8.36381 12.4157 8.36381H8.2771V0.0912781Z",
    fill: "#FF7262"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5543 12.5C16.5543 14.7832 14.7001 16.6363 12.4157 16.6363C10.1312 16.6363 8.2771 14.7832 8.2771 12.5C8.2771 10.2167 10.1312 8.36374 12.4157 8.36374C14.7001 8.36374 16.5543 10.2167 16.5543 12.5Z",
    fill: "#1ABCFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigma);
export default __webpack_public_path__ + "static/media/figma.25be87a2240fdd4fd455687fe59d0f6b.svg";
export { ForwardRef as ReactComponent };